/**
 * Use of this source code is governed by an MIT-style license that can be
 * found in the LICENSE file at https://github.com/NG-ZORRO/ng-zorro-antd/blob/master/LICENSE
 */

export default {
  locale: 'nb',
  DatePicker: {
    lang: {
      placeholder: 'Velg dato',
      rangePlaceholder: ['Startdato', 'Sluttdato'],
      locale: 'nb_NO',
      today: 'I dag',
      now: 'Nå',
      backToToday: 'Gå til i dag',
      ok: 'Ok',
      clear: 'Annuller',
      month: 'Måned',
      year: 'År',
      timeSelect: 'Velg tidspunkt',
      dateSelect: 'Velg dato',
      monthSelect: 'Velg måned',
      yearSelect: 'Velg år',
      decadeSelect: 'Velg årti',
      yearFormat: 'YYYY',
      dateFormat: 'DD.MM.YYYY',
      dayFormat: 'DD',
      dateTimeFormat: 'DD.MM.YYYY HH:mm:ss',
      monthBeforeYear: true,
      previousMonth: 'Forrige måned(PageUp)',
      nextMonth: 'Neste måned (PageDown)',
      previousYear: 'Forrige år (Control + left)',
      nextYear: 'Neste år (Control + right)',
      previousDecade: 'Forrige tiår',
      nextDecade: 'Neste tiår',
      previousCentury: 'Forrige århundre',
      nextCentury: 'Neste århundre'
    },
    timePickerLocale: {
      placeholder: 'Velg tid'
    }
  },
  TimePicker: {
    placeholder: 'Velg tid'
  },
  Calendar: {
    lang: {
      placeholder: 'Velg dato',
      rangePlaceholder: ['Startdato', 'Sluttdato'],
      locale: 'nb_NO',
      today: 'I dag',
      now: 'Nå',
      backToToday: 'Gå til i dag',
      ok: 'Ok',
      clear: 'Annuller',
      month: 'Måned',
      year: 'År',
      timeSelect: 'Velg tidspunkt',
      dateSelect: 'Velg dato',
      monthSelect: 'Velg måned',
      yearSelect: 'Velg år',
      decadeSelect: 'Velg årti',
      yearFormat: 'YYYY',
      dateFormat: 'DD.MM.YYYY',
      dayFormat: 'DD',
      dateTimeFormat: 'DD.MM.YYYY HH:mm:ss',
      monthBeforeYear: true,
      previousMonth: 'Forrige måned(PageUp)',
      nextMonth: 'Neste måned (PageDown)',
      previousYear: 'Forrige år (Control + left)',
      nextYear: 'Neste år (Control + right)',
      previousDecade: 'Forrige tiår',
      nextDecade: 'Neste tiår',
      previousCentury: 'Forrige århundre',
      nextCentury: 'Neste århundre'
    },
    timePickerLocale: {
      placeholder: 'Velg tid'
    }
  },
  Pagination: {
    items_per_page: '/ side',
    jump_to: 'Gå til side',
    page: '',
    prev_page: 'Forrige side',
    next_page: 'Neste side',
    prev_5: '5 forrige',
    next_5: '5 neste',
    prev_3: '3 forrige',
    next_3: '3 neste'
  },
  Table: {
    filterTitle: 'Filtermeny',
    filterConfirm: 'OK',
    filterReset: 'Nullstill',
    selectAll: 'Velg alle',
    selectInvert: 'Inverter valg'
  },
  Modal: {
    okText: 'OK',
    cancelText: 'Avbryt',
    justOkText: 'OK'
  },
  Popconfirm: {
    okText: 'OK',
    cancelText: 'Avbryt'
  },
  Transfer: {
    searchPlaceholder: 'Søk her',
    itemUnit: 'element',
    itemsUnit: 'elementer'
  },
  Upload: {
    uploading: 'Laster opp...',
    removeFile: 'Fjern fil',
    uploadError: 'Feil ved opplastning',
    previewFile: 'Forhåndsvisning',
    downloadFile: 'Last ned fil'
  },
  Empty: {
    description: 'Ingen data'
  }
};
